import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
} from "@apollo/client";
import { TokenRefreshLink } from "apollo-link-token-refresh";
import { createUploadLink } from "apollo-upload-client";

const url = "https://api.safatec.ir/graphql";
export const apiUrl = "https://api.safatec.ir/";

// const url = "http://localhost:4000/graphql";
// export const apiUrl = "http://localhost:4000/";

const AUTH_REFRESH_MUTATION = `
mutation AuthRefreshMutation($refreshInput: AuthRefreshInput!) {
  authRefresh(authRefreshInput: $refreshInput) {
    accessToken
    expiresAt
  }
}
`;

export const guest = new ApolloClient({
  link: createUploadLink({ uri: url }),
  cache: new InMemoryCache(),
});

export const authed = new ApolloClient({
  link: ApolloLink.from([
    new TokenRefreshLink({
      accessTokenField: "authRefresh",
      isTokenValidOrUndefined() {
        const expiresAt = localStorage.getItem("expiresAt");
        if (!expiresAt) return false;

        const expiresDate = Date.parse(expiresAt);
        return expiresDate - 2 * 60 * 1000 > Date.now();
      },
      fetchAccessToken() {
        return fetch(url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: AUTH_REFRESH_MUTATION,
            variables: {
              refreshInput: {
                refreshToken: localStorage.getItem("refreshToken"),
              },
            },
          }),
        });
      },
      handleFetch(authRefresh) {
        localStorage.setItem("accessToken", authRefresh.accessToken);
        localStorage.setItem("expiresAt", authRefresh.expiresAt);
      },
      handleError() {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("expiresAt");
        localStorage.removeItem("refreshToken");
        // window.location.href = "/login";
      },
    }),

    new ApolloLink((operation, forward) => {
      operation.setContext(({ headers = {} }) => {
        const accessToken = localStorage.getItem("accessToken");

        return {
          headers: {
            ...headers,
            ...(accessToken
              ? { authorization: `Bearer ${accessToken}` }
              : {}),
          },
        };
      });

      return forward(operation);
    }),

    createUploadLink({ uri: url }),
  ]),
  cache: new InMemoryCache({
    addTypename: false,
  }),
});
